"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNaverMap = void 0;
let loadStart = false;
const getNaverMap = (setter) => {
    if (loadStart)
        return;
    if (document.getElementById("NavarMap"))
        return;
    loadStart = true;
    const $naverMap = document.createElement("script");
    $naverMap.id = "NavarMap";
    $naverMap.defer = true;
    $naverMap.type = "text/javascript";
    $naverMap.src =
        "https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=zqdk36n102";
    document.head.appendChild($naverMap);
    const set = () => {
        setter(true);
        if (!$naverMap)
            return;
        $naverMap.removeEventListener("load", set);
    };
    if ($naverMap) {
        $naverMap.addEventListener("load", set);
    }
};
exports.getNaverMap = getNaverMap;
